import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CheckoutButton } from '../CheckoutButton';
import { CollectionMockup } from '../CollectionMockup';
import { OFFER_FEATURES } from '../../data/woodworking';
import { PRICE } from '../../data/checkout';

/**
 * Value stack + price (#offer). The hero CTA scrolls here.
 * `#offer-price` and `#offer-cta` drive the mobile sticky bar.
 */
export function OfferSection() {
  return <section id="offer" aria-labelledby="offer-title" className="bg-charcoal py-14 sm:py-20 lg:py-24" data-id="element-175" data-mp="1qhvuk5nz1zx">
      <div className="mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-176" data-mp="3swj98zd3q7oq">
        <SectionHeading id="offer-title" tone="dark" align="center" title="Get the complete furniture plan collection" data-id="element-177" data-mp="3sx2ebfhnl1lc" />

        <div className="mt-8 grid overflow-hidden rounded-[14px] bg-charcoal-raised shadow-[0_40px_80px_-40px_rgba(0,0,0,0.9)] ring-1 ring-white/10 sm:mt-10 lg:grid-cols-2" data-id="element-178" data-mp="3ixjz1ccou3zm">
          <div className="flex items-center justify-center border-b border-white/10 px-6 pb-6 pt-8 sm:px-10 lg:border-b-0 lg:border-r lg:p-10" data-id="element-179" data-mp="1arii6hrwxwgf">
            <CollectionMockup className="max-w-[360px] sm:max-w-[420px] lg:max-w-none" data-id="element-180" data-mp="1fkbld17qgwqe" />
          </div>

          <div className="px-5 pb-7 pt-6 sm:px-10 sm:pb-10 sm:pt-9" data-id="element-181" data-mp="10vnv9agnpf7u">
            <p className="wordmark text-[1.25rem] text-ivory sm:text-[1.5rem]" data-id="element-182" data-mp="15tz35fne5fnf">
              Woodworking Furniture Plans<sup className="ml-0.5 font-sans text-[0.5em] font-semibold" data-id="element-183" data-mp="1tjtgrzfjb88q">™</sup>
            </p>
            <p className="label-tech mt-3 text-olive-light" data-id="element-184" data-mp="1yga44rewtikr">60 projects across 6 digital volumes</p>

            <ul className="mt-6 grid gap-3" data-id="element-185" data-mp="1kh209l7sxma8">
              {OFFER_FEATURES.map(feature => <li key={feature} className="flex items-start gap-3 text-[1rem] leading-snug text-ivory" data-id="element-186" data-mp="1oi43ed4uaihh">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-forest text-olive-light ring-1 ring-olive/50" aria-hidden data-id="element-187" data-mp="91vfs87szxps">
                    <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-188" data-mp="2ft04lgw64i9s" />
                  </span>
                  {feature}
                </li>)}
            </ul>

            <div id="offer-price" className="mt-7 border-t border-white/10 pt-6 text-center" data-id="element-189" data-mp="25zjcqifldd8r">
              <p className="font-brand text-[3.6rem] font-bold leading-none tracking-[-0.01em] text-ivory sm:text-[4.2rem]" data-id="element-190" data-mp="2119efyyklwix">
                {PRICE.label}
              </p>
              <p className="mt-3 text-[0.95rem] text-parchment" data-id="element-191" data-mp="1s1376utgtss7">{PRICE.note}</p>
            </div>

            <CheckoutButton id="offer-cta" label={`GET THE COMPLETE COLLECTION — ${PRICE.label}`} size="lg" className="mt-6 w-full" data-id="element-192" data-mp="1n1ginp86sq43" />

            <p className="mt-4 text-center text-[0.86rem] leading-relaxed text-muted" data-id="element-193" data-mp="3hgj67hdody4d">
              Digital furniture plans. Physical furniture, tools, and materials are not included.
            </p>
          </div>
        </div>
      </div>
    </section>;
}